import * as React from 'react';
import { Select } from 'components';
import { usePrevious } from 'hooks';

interface BranchAccessProps {
  branches: Record<string, { name: string }>;
  setUserLocations: (locations: string[]) => void;
  userLocation: string;
  userLocations: string[];
}

const BranchAccess: React.FC<BranchAccessProps> = ({
  userLocation,
  branches,
  setUserLocations,
  userLocations,
}) => {
  const [isMissingBranch, setIsMissingBranch] = React.useState(false);

  const processLocations = (locations: string[] = []) => [
    userLocation,
    ...locations?.filter(location => location !== userLocation),
  ];

  const handleChange = (selectedLocations: string[]) => {
    setUserLocations(selectedLocations);
    setIsMissingBranch(!selectedLocations?.includes(userLocation));
  };

  const previousUserLocation = usePrevious(userLocation);

  React.useEffect(() => {
    let locationsWithOldLocationRemoved;
    if (previousUserLocation && previousUserLocation !== userLocation) {
      locationsWithOldLocationRemoved = userLocations.filter(
        (location: string) => location !== previousUserLocation,
      );
    }
    const newLocations = processLocations(
      locationsWithOldLocationRemoved || userLocations,
    );
    handleChange(newLocations);
  }, [userLocation]);

  const options = Object.entries(branches).map(([location, { name }]) => ({
    label: name,
    value: location,
  }));

  return (
    <div className="form-group">
      <label htmlFor="branch-access-select" className="col-sm-4 control-label">
        Branch Access:
      </label>
      <div className="col-sm-8">
        <Select
          id="branch-access-select"
          value={userLocations}
          onChange={handleChange}
          mode="multiple"
          placeholder="Branches this user is authorized to access"
          optionFilterProp="label"
          style={{ width: '100%' }}
          options={options}
        />
        {isMissingBranch && (
          <label className="error">
            Branch admin multi-access must include their own branch.
          </label>
        )}
      </div>
    </div>
  );
};

export default BranchAccess;
